import { createContext, useContext, useState, useCallback } from "react";

const LanguageContext = createContext({ lang: "fr", setLang: () => {} });

export function LanguageProvider({ children }) {
  const [lang, setLangState] = useState(() => {
    try {
      const urlLang = new URLSearchParams(window.location.search).get("lang");
      if (urlLang === "en" || urlLang === "fr") {
        localStorage.setItem("film_lang", urlLang);
        return urlLang;
      }
      const saved = localStorage.getItem("film_lang");
      return saved === "en" ? "en" : "fr";
    } catch {
      return "fr";
    }
  });

  const setLang = useCallback((l) => {
    setLangState(l);
    try { localStorage.setItem("film_lang", l); } catch { /* noop */ }
    document.documentElement.lang = l;
  }, []);

  return (
    <LanguageContext.Provider value={{ lang, setLang }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLang() {
  return useContext(LanguageContext);
}

/* Petit helper: tr(lang, { fr, en }) */
export function tr(lang, obj) {
  return obj[lang] ?? obj.fr;
}
